import {
  API_HISTORICO_MANUTENCAO,
  API_MAQUINAS_MANUTENCAO,
  API_ORDENS_MANUTENCAO,
} from '../api/apiConfig';
import {
  HistoricoManutencao,
  ManutencaoMaquina,
  OrdemManutencao,
} from '../types/manutencao';
import { createCrudService } from './crudFactory';

export const manutencaoMaquinasService = createCrudService<ManutencaoMaquina>(API_MAQUINAS_MANUTENCAO);
export const ordensManutencaoService =
  createCrudService<OrdemManutencao>(API_ORDENS_MANUTENCAO);
export const historicoManutencaoService =
  createCrudService<HistoricoManutencao>(API_HISTORICO_MANUTENCAO);
